export default function complaint({ context }) {

    const devUrl = 'https://staging18.staging.gb.ru/api/v2/'
    const prodUrl = 'https://gb.ru/api/v2/'

    const baseUrl = context.$config.isProd ? prodUrl : devUrl

    return {
        async setComplaint( complaintableType, complaintableId) {
            try {
                const { data } = await context.$axios.post(`${baseUrl}${complaintableType}/${complaintableId}/complaint`)

                return data
            } catch (e) {
                console.error(e)
            }
        }
    }
}
